package br.com.vvrefeicoes.portal.core.ui.layout

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

data class AppLayoutMetrics(
    val pagePadding: PaddingValues,
    val pageGap: Dp,
    val cardPadding: Dp,
    val cardGap: Dp,
)

@Composable
fun appLayoutMetrics(): AppLayoutMetrics {
    val density = LocalDensity.current
    val width =
        with(density) {
            LocalWindowInfo
                .current
                .containerSize
                .width
                .toDp()
        }
    return remember(width) { appLayoutMetrics(width) }
}

fun appLayoutMetrics(width: Dp): AppLayoutMetrics =
    when {
        width < 600.dp ->
            AppLayoutMetrics(
                pagePadding = PaddingValues(16.dp),
                pageGap = 24.dp,
                cardPadding = 16.dp,
                cardGap = 16.dp,
            )
        width < 1024.dp ->
            AppLayoutMetrics(
                pagePadding = PaddingValues(24.dp),
                pageGap = 24.dp,
                cardPadding = 24.dp,
                cardGap = 16.dp,
            )
        else ->
            AppLayoutMetrics(
                pagePadding = PaddingValues(32.dp),
                pageGap = 24.dp,
                cardPadding = 24.dp,
                cardGap = 16.dp,
            )
    }

fun appHeaderHorizontalPadding(width: Dp): Dp = if (width < 600.dp) 16.dp else 24.dp
